import types from '../actiontypes'

export const SetLayoutContentSearch = (path, value) => {
  return {
    type: types.LayoutContent.SetSearch,
    payload: {
      path,
      value
    }
  }
}

export const SetLayoutContentSearchDispatch = (dispatch) => {
  return (path, value) => {
    dispatch(SetLayoutContentSearch(path, value))
  }
}

export const ClearLayoutContentSearch = (path) => {
  return {
    type: types.LayoutContent.ClearSearch,
    payload: {
      path
    }
  }
}

export const ClearLayoutContentSearchDispatch = (dispatch) => {
  return (path) => {
    dispatch(ClearLayoutContentSearch(path))
  }
}

export const SetLayoutContentMenus = (path, value) => {
  return {
    type: types.LayoutContent.SetMenus,
    payload: {
      path,
      value
    }
  }
}

export const SetLayoutContentMenusDispatch = (dispatch) => {
  return (path, value) => {
    dispatch(SetLayoutContentMenus(path, value))
  }
}

export const SetLayoutContentMenusLoading = (path, loadingInfo) => {
  return {
    type: types.LayoutContent.SetMenusLoading,
    payload: {
      path,
      loadingInfo
    }
  }
}

export const SetLayoutContentMenusLoadingDispatch = (dispatch) => {
  return (path, loadingInfo) => {
    dispatch(SetLayoutContentMenusLoading(path, loadingInfo))
  }
}

export const AddLayoutContentMenu = (path, value) => {
  return {
    type: types.LayoutContent.AddMenu,
    payload: {
      path,
      value
    }
  }
}

export const AddLayoutContentMenuDispatch = (dispatch) => {
  return (path, value) => {
    dispatch(AddLayoutContentMenu(path, value))
  }
}

export const RemoveLayoutContentMenu = (path, id) => {
  return {
    type: types.LayoutContent.RemoveMenu,
    payload: {
      path,
      id
    }
  }
}

export const RemoveLayoutContentMenuDispatch = (dispatch) => {
  return (path, id) => {
    dispatch(RemoveLayoutContentMenu(path, id))
  }
}

export const ClearLayoutContentMenus = (path) => {
  return {
    type: types.LayoutContent.ClearMenus,
    payload: {
      path
    }
  }
}

export const ClearLayoutContentMenusDispatch = (dispatch) => {
  return (path) => {
    dispatch(ClearLayoutContentMenus(path))
  }
}

export const AddLayoutContentBreadCrumbKey = (key, value, disabled) => {
  return {
    type: types.LayoutContent.AddBreadCrumbKey,
    payload: {
      key,
      value,
      disabled: disabled === true
    }
  }
}

export const AddLayoutContentBreadCrumbKeyDispatch = (dispatch) => {
  return (key, value, disabled) => {
    dispatch(AddLayoutContentBreadCrumbKey(key, value, disabled))
  }
}

export const ClearLayoutContentBreadCrumbKeys = () => {
  return {
    type: types.LayoutContent.ClearBreadCrumbKeys
  }
}

export const ClearLayoutContentBreadCrumbKeysDispatch = (dispatch) => {
  return () => {
    dispatch(ClearLayoutContentBreadCrumbKeys())
  }
}
